import { render } from "./SplashWait.vue?vue&type=template&id=965c1f2e&scoped=true"
import script from "./SplashWait.vue?vue&type=script&lang=js"
export * from "./SplashWait.vue?vue&type=script&lang=js"

import "./SplashWait.vue?vue&type=style&index=0&id=965c1f2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965c1f2e"]])

export default __exports__